import React from 'react';
import BetCard from '~shared/components/react/BetCard';
import BetCardDescription from './BetCardDescription';
import BetCardHeader from './BetCardHeader';
import BetCardFooter from './BetCardFooter';
import { generateOddsBoostGtm } from '../utils';
import { ODDS_BOOST_LOCATIONS } from '../constants';

const oddsBoostList = (widgetEvents, commonDataEvents, oddsBoostLocation, source) => {
    const betCardList = [];

    widgetEvents.forEach((event) => {
        const { name, start_time, betable, category_name, category_slug } = commonDataEvents[event.event_id];
        const [market] = Object.values(commonDataEvents[event.event_id].markets);
        const betableCard = betable && market.betable;
        const category =
            (oddsBoostLocation === ODDS_BOOST_LOCATIONS.SPORTS_PAGE) ||
            (oddsBoostLocation === ODDS_BOOST_LOCATIONS.RACING_PAGE)
                ? ''
                : category_name;
        const selections = Object.values(market.selections);

        selections.forEach((selection) => {
            betCardList.push(
                <BetCard
                    key={event.event_id}
                    selections={[selection]}
                    description={<BetCardDescription data={{ event_name: name, selection }} />}
                    betable={betableCard}
                    betCardHeaderElement={<BetCardHeader categoryName={category} />}
                    betCardFooterElement={<BetCardFooter startTime={start_time} />}
                    gtmAttribute={generateOddsBoostGtm(oddsBoostLocation, category_slug, source)}
                />
            );
        });
    });

    return betCardList;
};

export default oddsBoostList;
